"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getAttr_1 = require("./getAttr");
exports.findBlockWithEl = (el, blocks) => {
    const id = getAttr_1.getAttr(el, 'id');
    const cid = getAttr_1.getAttr(el, 'cid');
    const block = blocks.find(b => {
        let idMatches = false;
        if (b.id) {
            idMatches = `${b.id}` === `${id}`;
        }
        let cidMatches = false;
        if (b.clientId) {
            cidMatches = `${b.clientId}` === `${cid}`;
        }
        return idMatches || cidMatches;
    });
    if (!block) {
        return false;
    }
    return block;
};
//# sourceMappingURL=findBlockWithEl.js.map